"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefActant = exports.RefAudit = exports.Ref = void 0;
class Ref {
}
exports.Ref = Ref;
class RefAudit {
}
exports.RefAudit = RefAudit;
class RefActant {
}
exports.RefActant = RefActant;
//# sourceMappingURL=resource.js.map